import { styled as muiStyled } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';

interface CustomProps {
  hasSelection: boolean;
}

export const CustomOutlinedInputGroup = muiStyled(OutlinedInput, {
shouldForwardProp: (prop) => prop !== 'hasSelection',})<CustomProps>(({ hasSelection }) => ({
  color: '#3C4043',

  '&.Mui-disabled': {
    cursor: 'wait',
    backgroundColor: "#f0f0f0",
  },

  '& .MuiOutlinedInput-root.Mui-disabled': {
    cursor: 'wait',
    backgroundColor: "#f0f0f0",
    color: "#a0a0a0",
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: "#c9c9c9",
    },
  },

  '& .MuiSelect-select.Mui-disabled': {
    cursor: 'wait',
    color: "#a0a0a0",
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: hasSelection ? '#c9c9c9' : 'transparent',
    borderRadius: '6px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  },

  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#c9c9c9',
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#c9c9c9',
  },

  '.MuiSelect-iconOpen': {
    transform: 'none !important',
  },

  borderRadius: '6px',
  border: 'none',
}));



export const CustomOutlinedInputRepresentation = muiStyled(OutlinedInput, {
shouldForwardProp: (prop) => prop !== 'hasSelection',})<CustomProps>(({ hasSelection }) => ({
    color: '#3C4043', //cor do texto dentro do input

    '&.Mui-disabled':{
        cursor: 'wait',
        backgroundColor: "#f0f0f0",
    },

    '& .MuiOutlinedInput-root.Mui-disabled':{
        cursor: 'wait',
        backgroundColor: "#f0f0f0", 
        color: "#a0a0a0", 
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#c9c9c9",
        },
    },

    '& .MuiSelect-select.Mui-disabled':{
        cursor: 'wait',
        color: "#a0a0a0",
    },

    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: hasSelection ? '#c9c9c9' : 'transparent', // Cor da borda
        borderRadius: '6px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.05)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#c9c9c9',

    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor:  '#c9c9c9' , // Cor da borda ao passar o mouse
    },
    '& .MuiSelect-iconOpen': {
        transform: 'none !important',
    },

    '@media (max-width:601px)': {
        width: '100%',
        fontSize: '14px', // Reduz a largura para 70% em telas maiores
    },
}));

export const StyledTextField = muiStyled(TextField)({
    width: '100%', 
    background: '#FFF', 
    minHeight: '52.16px', 
    borderRadius: '6px',
    cursor: 'pointer !important',
    color: '#3C4043', //cor do texto dentro do input
    '& .MuiOutlinedInput-input': {
        cursor: 'pointer !important',
    },
    '& .MuiOulinedInput-hover': {
        cursor: 'pointer !important',
        borderColor:'#c9c9c9',
    },
    '& .MuiOutlinedInput-root.Mui-disabled':{
        cursor: 'wait',
        backgroundColor: "#f0f0f0", 
        color: "#a0a0a0", 
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#c9c9c9",
        },
    },
    '& .MuiOutlinedInput-notchedOutline': {
        // borderColor:'#c9c9c9',
        // borderColor: periodFilterValue ? '#c9c9c9' : 'transparent', // Cor da borda
        borderRadius: '6px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.05)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#c9c9c9',

    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#c9c9c9', // Cor da borda ao passar o mouse
    },
    '.MuiSelect-iconOpen': {
        transform: 'none !important',
    },

    '@media (max-width:601px)': {
        width: '100%',
        fontSize: '14px', // Reduz a largura para 70% em telas maiores
    },
});


export const StyledDivMonthPicker = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  overflow-y: auto;

  @media (min-width: 815px) {
    width: 100%;
    flex-direction: row;
  }
`;
